import { BehaviorSubject } from 'rxjs/BehaviorSubject';
import { Injectable } from '@angular/core';
import { ApiEndpoints } from './api-endpoints.service';
import { environment } from '../../../environments/environment';

const Base64 = require('js-base64').Base64;

@Injectable({
  providedIn: 'root',
})
export class PropertyFinder {
  constructor(private apiEndpoint: ApiEndpoints) {}

  //   public getPropertyFinderList: BehaviorSubject<any> = new BehaviorSubject<any>('');

  //   public updateLead(lead): void {
  //     this.updateEditedLead.next(lead);
  //   }

  getPropertiesList(object) {
    var params = this.parseSearchQuery(object);
    Object.keys(params).forEach(
      key => params[key] == null && delete params[key],
    );
    return this.apiEndpoint.get('getpropertyFinderList', params);
  }

  parseSearchQuery = function (params) {
    let readyQuery = {
      miles: params.miles || 250,
      min_budget: params.min_budget,
      max_budget: params.max_budget,
      rental_sort: params.rental_sort.toLowerCase(),
      max_beds: params.max_beds === 5 ? null : params.max_beds,
      min_beds: params.min_beds === 0 ? null : params.min_beds,
      max_baths: params.max_baths === 5 ? null : params.max_baths,
      min_baths: params.min_baths === 0 ? null : params.min_baths,
      page: params.serverPage,
      items: params.items,
      locations: '',
      center_lng: null,
      center_lat: null,
      execlude_id_list: null,
      property_type: null,
      include_private_idx: params.include_private_idx || true,
    };
    if (params.locations.length > 1) {
      readyQuery.locations = Base64.encode(JSON.stringify(params.locations));
    } else if (params.locations.length === 1) {
      readyQuery.locations = Base64.encode(JSON.stringify(params.locations));
      readyQuery.center_lng = params.locations[0].center_lng;
      readyQuery.center_lat = params.locations[0].center_lat;
    }
    if (params.execlude_id_list.length) {
      readyQuery.execlude_id_list = Base64.encode(
        JSON.stringify(params.execlude_id_list),
      );
    }
    if (params.property_type.length) {
      readyQuery.property_type = Base64.encode(
        JSON.stringify(params.property_type),
      );
    }
    return readyQuery;
  };

  getRedfinEstimation(propertyId, state) {
    let queryData = {
      state: state,
      _t: 'QcG6kP3yDnUHD67hWAAQyqrDdFm4gBPW',
    };
    return this.apiEndpoint.get('redfinEstimate', queryData, {
      propertyId: propertyId,
    });
  }

  buildPropertylink(data) {
    if (data.address && data.city && data.id) {
      let propertyLink = [
        environment.urlDomain,
        '/explore/#!/property/analysis/',
        data.neighborhood.name,
        '-',
        data.city.replace(/\s+/gi, '-'),
        '-',
        data.state,
        '/',
        data.address.replace('#', '-'),
        '/home/',
        data.id,
      ].join('');
      propertyLink = propertyLink
        .toLowerCase()
        .replace(/\s+/gi, '-')
        .replace(/[&,+()$~%'"*?<>{}]/g, '');
      return propertyLink;
    }
    return `${environment.urlDomain}/explore/#!/search`;
  }

  parseLocationComponents(components) {
    let location = {
      city: null,
      state: null,
      country: null,
      zipCode: null,
      neighborhood: null,
      streetNumber: null,
      routeLong: null,
      routeShort: null,
      lat: null,
      lng: null,
    };

    for (let index in components.address_components) {
      var component = components.address_components[index];
      if (component.types && component.types[0] == 'locality') {
        location.city = component.long_name;
        continue;
      } else if (
        component.types &&
        component.types[0] == 'administrative_area_level_2'
      ) {
        if (!location.city) location.city = component.long_name;
        continue;
      }

      if (
        component.types &&
        component.types[0] == 'administrative_area_level_1'
      ) {
        location.state = component.short_name;
        continue;
      }

      if (component.types && component.types[0] == 'country') {
        location.country = component.long_name;
        continue;
      }

      if (component.types && component.types[0] == 'postal_code') {
        location.zipCode = component.long_name;
        continue;
      }

      if (component.types && component.types[0] == 'neighborhood') {
        location.neighborhood = component.long_name;
        continue;
      }

      if (component.types && component.types[0] == 'street_number') {
        location.streetNumber = component.long_name;
      }
      if (component.types && component.types[0] == 'route') {
        location.routeLong = component.long_name;
        location.routeShort = component.short_name;
      }
    }

    if (components.geometry.location) {
      location.lat = components.geometry.location.lat();
      location.lng = components.geometry.location.lng();
    }

    return location;
  }

  getBounds(cities, googleLoader) {
    let myService = this;
    let promises = [];
    let myCities = cities.map(e => {
      return `${e.city}, ${e.state}`;
    });
    return googleLoader.load().then(() => {
      let geocoder = new google.maps.Geocoder();
      for (var i in myCities) {
        let myPromise = new Promise((resolve, reject) => {
          geocoder.geocode(
            { address: myCities[i] },
            function (results, status) {
              if (status == google.maps.GeocoderStatus.OK) {
                resolve(myService.parseLocationComponents(results[0]));
              } else {
                resolve(status);
              }
            },
          );
        });
        promises.push(myPromise);
      }
      return Promise.all(promises).then(
        values => {
          return values;
        },
        reason => {
          return reason;
        },
      );
    });
  }

  getPropertyFinderRecommender(leadId) {
    return this.apiEndpoint.get('fetchPropertyRecommender', {}, { leadId });
  }
}
